export default __webpack_public_path__ + "static/media/login.7d212622.png";